import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing a refresh icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <RefreshIcon width={12} />
 */
const RefreshIcon = props => (
    <SvgIcon {...props}>
        <path d="M35.3,12.7A16,16,0,1,0,39.46,28H35.3A12,12,0,1,1,23.99,12a11.841,11.841,0,0,1,8.445,3.56L25.991,22H40V8Z" />
    </SvgIcon>
)

RefreshIcon.defaultProps = defaultProps

export { RefreshIcon }
